module.exports = __webpack_public_path__ + "img/lingyangliuc.8ab6f515.png";